import { render, staticRenderFns } from "./customer-searchbar.vue?vue&type=template&id=75b6dcaf&"
import script from "./customer-searchbar.vue?vue&type=script&lang=js&"
export * from "./customer-searchbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports